import { useRef, useState } from "react";
import { ReactComponent as IconWeb } from "../../../assets/svg/icon-language.svg";
import { ReactComponent as IconDropdownDark } from "../../../assets/svg/icon-arrow-down.svg";
import useDropdownClose from "../../../utils/useDropdownClose";

/** Language dropdown shared by the auth top bar and the split login/signup layout. */
function LanguageSelector({ currentLanguage, languageOptions, changeLanguage, className = "" }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  useDropdownClose(isOpen, () => setIsOpen(false), dropdownRef);

  const handleLanguageChange = async (langValue) => {
    await changeLanguage(langValue);
    setIsOpen(false);
  };

  // Normalizes the language code (drops the regional part).
  const normalizedCurrentLanguage = currentLanguage?.split("-")[0];
  const currentOption = languageOptions.find((option) => option.value === normalizedCurrentLanguage);
  const currentLabel = currentOption ? currentOption.label : languageOptions[0]?.label;

  return (
    <div
      ref={dropdownRef}
      className={`language-selector ${className}`.trim()}
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
      onClick={() => setIsOpen(true)}
    >
      <IconWeb />
      <p>{currentLabel}</p>
      <IconDropdownDark className={`language-icon-arrow ${isOpen ? "open" : ""}`} />

      {isOpen && (
        <div className="box-dropdown box-dropdown-right">
          {languageOptions.map((option) => (
            <p
              key={option.value}
              className={currentLanguage === option.value ? "box-dropdown--selected" : ""}
              onClick={(event) => {
                event.stopPropagation();
                handleLanguageChange(option.value);
              }}
            >
              {option.label}
            </p>
          ))}
        </div>
      )}
    </div>
  );
}

export default LanguageSelector;
